export const ROLES = {
  ADMIN:   'admin',
  PM:      'project_manager',
  VIEWER:  'viewer',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

export const ROLE_LABELS: Record<Role, string> = {
  admin:           'Admin',
  project_manager: 'Project Manager',
  viewer:          'Viewer',
};

export const ROLE_COLOURS: Record<Role, string> = {
  admin:           'badge-navy',
  project_manager: 'badge-ocean',
  viewer:          'badge-muted',
};

/** Permissions matrix — what each role can do */
export const PERMISSIONS = {
  admin: {
    canManageUsers:    true,
    canApproveBudget:  true,
    canDeleteProject:  true,
    canViewReports:    true,
    canEditProject:    true,
    canCreateProject:  true,
  },
  project_manager: {
    canManageUsers:    false,
    canApproveBudget:  false,
    canDeleteProject:  false,
    canViewReports:    true,
    canEditProject:    true,
    canCreateProject:  true,
  },
  viewer: {
    canManageUsers:    false,
    canApproveBudget:  false,
    canDeleteProject:  false,
    canViewReports:    true,
    canEditProject:    false,
    canCreateProject:  false,
  },
} satisfies Record<Role, Record<string, boolean>>;

export type Permission = keyof (typeof PERMISSIONS)[Role];